import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { CreateArticle } from '../../../pages/CreateArticle'

const newArticleSearchSchema = z.object({
  // A title to start from - Search insights offers one for a search that found nothing
  title: z.string().max(255).optional(),
})

export const Route = createFileRoute('/helpdesk/knowledge-base/new')({
  component: CreateArticle,
  validateSearch: newArticleSearchSchema,
})
